<p-drawer
  [visible]="display"
  position="right"
  (onHide)="onHide()"
  appendTo="body"
  class="sidebarWidth">
  <div class="mb-2 left-sidebar">
    <h1 class="mb-3">Add notes</h1>

    <div>
      <div class="col-12 mb-4">
        <div class="has-float-label">
          <textarea
            jniAutoCompleteBlocker
            name="Notes"
            type="text"
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="notes"></textarea>
          <label class="form-label" for="notes">Notes</label>
        </div>
      </div>
    </div>

    <div>
      <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!notes"
        (click)="saveNotes()">
        save
      </button>
    </div>
  </div>
</p-drawer>
